import { a11yClick } from './util';

(function(Drupal, $, once) {
  'use strict';

  Drupal.behaviors.dropdown = {
    attach: function(context, settings) {

      $(once('dropdown', '.dropdown-wrapper', context)).each(function() {
        let $dropdownWrapper = jQuery(this);
        let $dropdownToggle = $dropdownWrapper.find('.dropdown-toggle');
        let $dropdownContent = $dropdownWrapper.find('.dropdown-content');

        $dropdownToggle.on('click keyup', function(event) {
          event.stopPropagation();
          event.preventDefault();

          if (a11yClick(event) === true) {
            $dropdownContent.slideToggle('fast');
            $dropdownToggle.toggleClass('active');
          }
        });

      });
    }
  };

})(Drupal, jQuery, once);
